<template>
    <v-select
        v-model="selectedCampus"
        label="name"
        placeholder="Search..."
        :options="campuses"
        :clearable="clearable"
        @search="onSearch"
    >
        <template slot="no-options">
            Start typing to search for a campus
        </template>
    </v-select>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    props: {
        value: {
            type: String,
            required: false,
            default: null
        },
        clearable: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    data() {
        return {
            selectedCampus: null,
            campuses: []
        };
    },

    watch: {
        selectedCampus() {
            this.$emit(
                'input',
                this.selectedCampus ? this.selectedCampus.id : null
            );
        }
    },

    async created() {
        try {
            const { rows } = await this.getCampuses();

            this.campuses = rows;

            const id = this.value;

            if (!id) {
                return;
            }

            this.selectedCampus = await this.getCampus(id);
        } catch (error) {
            console.error(error);
        }
    },

    methods: {
        ...mapActions({
            getCampuses: 'campuses/index',
            getCampus: 'campuses/show'
        }),

        async onSearch(search, loading) {
            if (!search) {
                this.campuses = this.selectedCampus
                    ? [this.selectedCampus]
                    : [];

                return;
            }

            loading(true);

            try {
                const { rows: campuses } = await this.getCampuses({
                    search
                });

                if (
                    this.selectedCampus &&
                    campuses.every(
                        campus => campus.id !== this.selectedCampus.id
                    )
                ) {
                    campuses.push(this.selectedCampus);
                }

                this.campuses = campuses;
            } catch (error) {
                console.error(error);

                this.$toasterError();
            }

            loading(false);
        }
    }
};
</script>
